module.exports = __webpack_public_path__ + "static/img/favicon.04f0efa.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/favicon.ico
// module id = gy05
// module chunks = 1